import React from "react";

import { makeStyles } from "@material-ui/styles";
import Tabs from "@material-ui/core/Tabs";
import KTab from "./KTab";
import { TabInterface } from "../../../interfaces/tab-interface";

const useStyle = makeStyles(() => ({
  root: {
    minHeight: "26px",
    height: "26px",
  },
  flexContainer: {
    height: "26px",
  },
  indicator: {
    color: "#0066b3",
  },
}));

interface Props {
  tabs: TabInterface[];
  handleChange: (v?, v1?) => void | undefined;
  activeTab: string | number | undefined;
}

const KTabs = ({ tabs, handleChange, activeTab }: Props) => {
  const classes = useStyle();

  return (
    <div>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        classes={{ root: classes.root }}
      >
        {tabs.map((el) => (
          // @ts-ignore
          <KTab label={el.label} value={el.value} key={el.value} />
        ))}
      </Tabs>
    </div>
  );
};

export default KTabs;
